// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

function initialiseSwiper() {

    let $swiper = $('.swiper-container')

    const SLIDE_DURATION = 16000

    $.each($swiper, (index, item) => {
        
        // The swiper item.
        let $item = $(item);
        
        // Pagination
        let pagination = false
        if ($item.find('.swiper-pagination').length > 0) {
            pagination = {
                el: $item.find('.swiper-pagination')[0],
                clickable: true,
            }
        }
        
        // Navigation
        let navigation = false
        if ($item.find('.swiper-button-next').length > 0 || $item.find('.swiper-button-prev').length > 0) {
            navigation = {
                nextEl: $item.find('.swiper-button-next')[0],
                prevEl: $item.find('.swiper-button-prev')[0],
            }
        }

        // Navigation if carousel.
        if ($item.parents('.collection-carousel').length > 0) {
            let $pagination = $item.parents('.collection-carousel')
            navigation = {
                nextEl: $pagination.find('.swiper-button-next')[0],
                prevEl: $pagination.find('.swiper-button-prev')[0],
            }
        }
    
        let swiper = new Swiper(item, {
            on: {
                afterInit: function() {
                    MatchHeight.init()
                }
            },
            // Direction
            direction: $item.data('direction') ? $item.data('direction') : 'horizontal',
            // Loop
            loop: $item.data('loop') ? true : false,
            // Slide per view
            slidesPerView: $item.data('slides-per-view') ? $item.data('slides-per-view') : 1,
            // Slide per view
            slidesPerGroup: $item.data('slides-per-group') ? $item.data('slides-per-group') : 1,
            // Spacing
            spaceBetween : $item.data('space-between') ? $item.data('space-between') : 0,
            // Autoplay
            autoplay: {
                disableOnInteraction : false,
                delay: SLIDE_DURATION,
            },
            // Navigation - Pagination
            pagination: pagination,
            // Navigation - Arrows
            navigation: navigation,
            // And if we need scrollbar
            scrollbar: {
                el: '.swiper-scrollbar',
            },
             // Responsive breakpoints
            breakpoints: {
                640: {
                    slidesPerView: $item.data('slides-per-view-sm') ? $item.data('slides-per-view-sm') : 1,
                    slidesPerGroup: $item.data('slides-per-group-sm') ? $item.data('slides-per-group-sm') : 1,
                },
                768: {
                    slidesPerView: $item.data('slides-per-view-md') ? $item.data('slides-per-view-md') : 1,
                    slidesPerGroup: $item.data('slides-per-group-md') ? $item.data('slides-per-group-md') : 1,
                },
                1024: {
                    slidesPerView: $item.data('slides-per-view-lg') ? $item.data('slides-per-view-lg') : 2,
                    slidesPerGroup: $item.data('slides-per-group-lg') ? $item.data('slides-per-group-lg') : 2,
                },
                1280: {
                    slidesPerView: $item.data('slides-per-view-xl') ? $item.data('slides-per-view-xl') : 3,
                    slidesPerGroup: $item.data('slides-per-group-xl') ? $item.data('slides-per-group-xl') : 3,
                },
                1536: {
                    slidesPerView: $item.data('slides-per-view-xxl') ? $item.data('slides-per-view-xxl') : 3,
                    slidesPerGroup: $item.data('slides-per-group-xxl') ? $item.data('slides-per-group-xxl') : 3,
                }
            },
        });
    
    })
}

initialiseSwiper()

if (Shopify.designMode) {
    
    document.addEventListener('shopify:section:load', function(){
        initialiseSwiper()
    })

}